/**
 * Airtable MOCK Service for testing
 * Uses sample data to test the app without Airtable token
 */

import {
  AirtableCustomer,
  SelfIPA,
  BonusInfo,
  ShippingTracking,
  Ticket,
} from '../types/airtable';

// Mock data based on real Airtable data
const mockCustomerData: AirtableCustomer = {
  id: 'rec00IxMqy11SWTCE',
  uid: '134560 - PV',
  nome: 'Maria Vittoria Gagliardi',
  email: 'test@enpal.com',
  telefono: '+39 333 1234567',
  indirizzo: 'Via Roma 123, Milano, 20100',
  installStatus: 'In Progress',
  tipoProdotto: 'Fotovoltaico + Storage',
  projectManager: 'Marco Rossi',
  buildabilityOutcome: 'Approved',
  ipaAppointment: '2026-01-20T10:00:00.000Z',
  dataFirmaContratto: '2025-12-15T00:00:00.000Z',
  'Contratto: Nome e cognome': 'Maria Vittoria Gagliardi',
  'Contact[First Name]': 'Maria Vittoria',
  'Contact[Last Name]': 'Gagliardi',
  'Numero telefono': '+39 333 1234567',
  'Indirizzo Impianto': 'Via Roma 123, Milano, 20100',
  'Install Status': 'In Progress',
  'Tipo Prodotto & Incentivo': 'Fotovoltaico + Storage',
  'Project Manager': { name: 'Marco Rossi' },
  'Buildability outcome': 'Approved',
  'IPA appointment': '2026-01-20T10:00:00.000Z',
  'Data firma contratto': '2025-12-15T00:00:00.000Z',
  'Final Modules sold': 12,
  'Potenza di generazione': '6.5 kWp',
  'Grid Status': 'Connection In Progress',
  'Installatore': 'Eco Solar SRL',
  'Planning 3 picture': [
    {
      id: 'att001',
      url: 'https://via.placeholder.com/800x600/00B4D8/FFFFFF?text=Layout+Impianto',
      filename: 'planning_layout.pdf',
      type: 'application/pdf',
    },
  ],
  'Planning 3 Proposal Link': 'https://example.com/planning3-proposal',
};

const mockSelfIPAPV: SelfIPA[] = [
  {
    id: 'recIPA001',
    'Created time': '2025-12-20T14:30:00.000Z',
    Status: 'Approved',
    Notes: 'Sopralluogo completato con successo',
  },
];

const mockSelfIPAHP: SelfIPA[] = [
  {
    id: 'recIPAHP001',
    'Created time': '2025-12-22T09:00:00.000Z',
    Status: 'Pending Review',
    Notes: 'In attesa di approvazione tecnica',
  },
];

const mockTickets: Ticket[] = [
  {
    id: 'recTicket001',
    Subject: 'Richiesta informazioni installazione',
    Description:
      "Vorrei sapere quando è prevista l'installazione del mio impianto",
    Status: 'In Progress',
    Priority: 'Medium',
    'Created time': '2026-01-10T11:00:00.000Z',
    'Assigned To': 'Marco Rossi',
    Category: 'Installazione',
  },
  {
    id: 'recTicket002',
    Subject: 'Domanda su bonus fiscali',
    Description: 'Posso avere dettagli sul Reddito Energetico?',
    Status: 'Resolved',
    Priority: 'Low',
    'Created time': '2026-01-05T15:30:00.000Z',
    'Assigned To': 'Laura Bianchi',
    Category: 'Bonus',
  },
];

const mockBonus: BonusInfo[] = [
  {
    id: 'recBonus001',
    'Incentive Type': 'Reddito Energetico (RedEn)',
    Description: 'Contributo a fondo perduto per impianto fotovoltaico',
    Status: 'Approved',
    Amount: 8500,
    'Application Date': '2025-12-01T00:00:00.000Z',
    Notes: 'Domanda approvata, erogazione prevista entro 90 giorni',
  },
  {
    id: 'recBonus002',
    'Incentive Type': 'Conto Termico 2.0',
    Description: 'Incentivo per pompa di calore',
    Status: 'In Progress',
    Amount: 3200,
    'Application Date': '2025-12-10T00:00:00.000Z',
    Notes: 'Pratica in elaborazione presso GSE',
  },
];

const mockShippingTracking: ShippingTracking[] = [
  {
    id: 'recShip001',
    Status: 'In transito',
    'Tracking Number': 'SDA1234567890',
    'Expected Delivery': '2026-01-18T00:00:00.000Z',
    Courier: 'SDA Express',
  },
];

// Simulate network delay
const delay = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const AirtableMockService = {
  async loginByEmail(email: string): Promise<AirtableCustomer | null> {
    await delay(800);

    // Accept any email for testing
    return {
      ...mockCustomerData,
      email: email,
    };
  },

  async getCustomerData(_uid: string): Promise<AirtableCustomer | null> {
    await delay(500);
    return mockCustomerData;
  },

  async getSelfIPAPV(_customerRecordId: string): Promise<SelfIPA[]> {
    await delay(400);
    return mockSelfIPAPV;
  },

  async getSelfIPAHP(_customerRecordId: string): Promise<SelfIPA[]> {
    await delay(400);
    return mockSelfIPAHP;
  },

  async getTickets(_uid: string): Promise<Ticket[]> {
    await delay(500);
    return mockTickets;
  },

  async getBonusInfo(_uid: string): Promise<BonusInfo[]> {
    await delay(500);
    return mockBonus;
  },

  async getInstallationSlots(): Promise<unknown[]> {
    await delay(500);
    return [];
  },

  async getShippingTracking(_uid: string): Promise<ShippingTracking[]> {
    await delay(400);
    return mockShippingTracking;
  },
};

export default AirtableMockService;
